package com.karawek.core.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Convenience for navigation rows.
 *
 * Combines CoreListItem + Title/Subtitle + Chevron.
 */
@Composable
fun CoreNavRow(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    CoreListItem(
        text = text,
        onClick = onClick,
        modifier = modifier,
    )
}

